// extracted by mini-css-extract-plugin
module.exports = {"label":"CreateUserPage_label__McbU3"};